/**
 * Maker-rebate display gate. The Kalshi Market Maker Program rebate is folded
 * into maker-perspective fee + odds estimates only when BOTH:
 *   - the trader's org is enrolled in the program (AuthUser.mmRebateEnabled,
 *     set by a manager, delivered via /api/trader/me), AND
 *   - the trader has the "MM Rebate" display toggle on (displaySettings).
 *
 * The actual rebate fraction for a given market (50% pregame / 100% live) is
 * computed by `makerRebatePct` in @/lib/pricing/makerRebate; this hook only
 * answers "is the rebate active at all." Surfaces multiply the two together:
 * `useMakerRebateActive() ? makerRebatePct({ isLive }) : 0`.
 *
 * See [[project_kalshi_mm_rebate_model]].
 */
import { useAuthStore } from '@/stores/authStore';
import { useDisplaySettings } from '@/stores/displaySettings';

export function useMakerRebateActive(): boolean {
  const enrolled = useAuthStore((s) => s.user?.mmRebateEnabled ?? false);
  const toggleOn = useDisplaySettings((s) => s.makerRebateEnabled);
  return enrolled && toggleOn;
}
